module.exports = __webpack_public_path__ + "static/img/indexBgTitle.6ab1ac5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/indexBgTitle.png
// module id = H/wZ
// module chunks = 1